<p>Updating model <b>{{modelName}} [{{model?.modelType}}]</b></p>
<ng-container [ngSwitch]="currentState">
    <ng-container *ngSwitchDefault>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>IFC</acabim-form-input-label>
            <acabim-form-input-content>
                <acabim-file-upload #ifcFileUpload class="p-field" [type]="'.ifc'"></acabim-file-upload>
                <ng-container *ngIf="ifcFileUpload.fileName">
                    <div>{{ifcFileUpload.fileName}}</div>
                    <div>
                        <button (click)="ifcFileUpload.resetFile()" class="cas-button-action">Reset</button>
                    </div>
                </ng-container>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <div class="cas-action-buttons">
            <button (click)='updateModel()' class="cas-button-action">Update Model</button>
        </div>
    </ng-container>

    <div class="p-5" *ngSwitchCase="1">
        <h6>Uploading file</h6>
        <p-progressBar [value]="currentUploadProgress"></p-progressBar>
    </div>

    <div class="p-5" *ngSwitchCase="2">
        <h6>Processing file</h6>
        <p-progressBar mode="indeterminate"></p-progressBar>
    </div>
</ng-container>

